import { AdminBarberRepository } from "../../Repository";

export async function changePhoneNumber(
  fullName: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.setPhoneNumber(fullName);
}
